import React, { createContext, useState } from 'react';
import { MyWorkListDataI } from './MyWork';
import { ListColumnKey, MyWorkListViewType, TICKET_PAGINATION } from '../../shared/utils/constants';
import { EnumSortOrderType } from '../toolbar/CustomViewContextProvider';

interface PropTypes {
  children: React.ReactNode;
}

export interface MyWorkContextType {
  myWorkStates: MyWorkStatesType;
  setMyWorkStates: React.Dispatch<React.SetStateAction<MyWorkStatesType>>;
}

// What the list is fetched by when nothing has been chosen (the query fell back to this already); stated
// here so the Id header shows its arrow.
export const DEFAULT_SORT_ORDER_MY_WORK: ISortOrder = { orderBy: ListColumnKey.Id, orderType: EnumSortOrderType.desc };

export const MyWorkContext = createContext({} as MyWorkContextType);
const MyWorkProvider = MyWorkContext.Provider;

export const DEFAULT_MY_WORK_VALUES: MyWorkStatesType = {
  showClosed: false,
  sortOrder: {
    [MyWorkListViewType.All]: DEFAULT_SORT_ORDER_MY_WORK,
    [MyWorkListViewType.Tickets]: DEFAULT_SORT_ORDER_MY_WORK,
    [MyWorkListViewType.Tasks]: DEFAULT_SORT_ORDER_MY_WORK,
    [MyWorkListViewType.Approvals]: DEFAULT_SORT_ORDER_MY_WORK,
  },
  myWorkList: {
    isFetching: true,
    allData: [] as MyWorkListDataI[],
    currentPage: 1,
    countPerPage: TICKET_PAGINATION.ITEM_PER_PAGE(),
    dataCount: {
      [MyWorkListViewType.All]: 0,
      [MyWorkListViewType.Tickets]: 0,
      [MyWorkListViewType.Tasks]: 0,
      [MyWorkListViewType.Approvals]: 0,
    },
    selectedTabId: MyWorkListViewType.All,
  },
  useCustomProperties: false    
};

const MyWorkContextProvider = ({ children }: PropTypes) => {
  const [myWorkStates, setMyWorkStates] = useState<MyWorkStatesType>({ ...DEFAULT_MY_WORK_VALUES, myWorkList: { ...DEFAULT_MY_WORK_VALUES.myWorkList, countPerPage: TICKET_PAGINATION.ITEM_PER_PAGE() } });

  return (
    <>
      <MyWorkProvider value={{ myWorkStates, setMyWorkStates }}>
        <>{children}</>
      </MyWorkProvider>
    </>
  );
};

export default MyWorkContextProvider;
